module.exports = __webpack_public_path__ + "img/logo.c4d3de7e.png";